import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';

const PreviewPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Activando modo preview...');

  // Obtener la acción desde los query params (?action=clear)
  const action = searchParams.get('action');

  useEffect(() => {
    if (action === 'clear') {
      // Eliminar la cookie de preview
      Cookies.remove('preview', { path: '/' });
      setMessage('Desactivando modo preview...');

      // Redirigir después de un breve delay
      setTimeout(() => {
        navigate('/');
      }, 500);
    } else {
      // Establecer la cookie de preview
      Cookies.set('preview', '1', {
        expires: 7, // La cookie expira en 7 días
        path: '/', // Disponible en todo el sitio
        sameSite: 'lax' // Para seguridad
      });
      setMessage('Activando modo preview...');

      // Redirigir a la página principal después de un breve delay
      setTimeout(() => {
        navigate('/');
      }, 500);
    }
  }, [navigate, action]);

  // Mostrar un indicador de carga mientras se procesa
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center px-6">
        <div className="bg-white border-2 border-gray-900 rounded-2xl p-8">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"></div>
          <p className="text-gray-900 font-medium text-lg">{message}</p>
          <p className="text-gray-600 text-sm mt-2">
            Serás redirigido en un momento...
          </p>
        </div>

        {/* Información útil */}
        <div className="mt-8 text-sm text-gray-500">
          <p className="mb-2">Enlaces útiles para modo preview:</p>
          <div className="flex flex-col gap-2 items-center">
            <a
              href="/preview"
              className="text-gray-700 hover:text-gray-900 underline"
              onClick={(e) => e.preventDefault()}
            >
              /preview - Activar modo preview
            </a>
            <a
              href="/preview?action=clear"
              className="text-gray-700 hover:text-gray-900 underline"
              onClick={(e) => e.preventDefault()}
            >
              /preview?action=clear - Desactivar modo preview
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewPage;